import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Button } from 'foundations-components/transitional/components/Button';
import { Small } from 'foundations-components/transitional/components/Small';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Section } from 'foundations-components/transitional/components/Section';
import { useCallback, useContext, useRef, useState } from 'react';
import { ACTIONS, SCREENS } from '../../constants/Tracking';
import { AppContext } from '../../contexts/app/context';
import { CommentsPropsContext } from '../../contexts/comments/PropsContext';
import { CommentsContext } from '../../contexts/comments/context';
import EditHOC from '../../hoc/EditHOC';
import useProsemirrorEditor from '../../hooks/useProsemirrorEditor';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CommentRichTextEditor({
  onSave,
  initialValue = '',
  onCancel,
  dataTestId
}) {
  const {
    portalId,
    usageTracker,
    apiWrapper,
    openUrl,
    prosemirrorTrackerProperties
  } = useContext(CommentsPropsContext);
  const {
    isPastMeeting,
    appName
  } = useContext(AppContext);
  const {
    owners,
    isOwnersLoaded,
    isSnippetLoading,
    commentsActions
  } = useContext(CommentsContext);
  const isInteractionTracked = useRef(false);
  const [proseMirrorEditorState, setProseMirrorEditorState] = useState(initialValue);
  const onProseMirrorContentChange = useCallback(newEditorState => {
    if (newEditorState && !isInteractionTracked.current) {
      usageTracker.trackInteraction(Object.assign({
        screen: SCREENS.comments
      }, ACTIONS.comments.new));
      isInteractionTracked.current = true;
    }
    setProseMirrorEditorState(newEditorState);
  }, [setProseMirrorEditorState, usageTracker]);
  const snippetsCallback = useCallback((isLoading = false) => {
    commentsActions.setSnippetLoading(isLoading);
  }, [commentsActions]);
  const {
    blankComponent,
    prosemirrorEditor,
    resetEditorState,
    hasContent
  } = useProsemirrorEditor({
    mentionOwners: owners,
    apiWrapper: apiWrapper.snippets,
    portalId,
    openUrl,
    needToInit: isOwnersLoaded,
    initialValue,
    onChange: onProseMirrorContentChange,
    prosemirrorTrackerProperties,
    defaultComponent: /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    }),
    snippetsCallback
  });
  const onProseMirrorSaveComment = () => {
    onSave({
      newComment: proseMirrorEditorState,
      time: I18n.moment()
    });
    resetEditorState();
  };
  if (blankComponent) return blankComponent;
  return /*#__PURE__*/_jsxs(Section, {
    "data-test-id": dataTestId,
    padding: "300",
    marginBlockEnd: "0",
    children: [/*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: I18n.moment(),
        format: "LT",
        type: "userTz"
      })
    }), /*#__PURE__*/_jsx(EditHOC, {
      isPastMeeting: isPastMeeting,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [prosemirrorEditor, /*#__PURE__*/_jsx(Button, {
          "data-test-id": `${appName}-rich-text-editor-save-button`,
          use: "primary",
          responsive: false,
          size: "xs",
          onClick: onProseMirrorSaveComment,
          disabled: !hasContent || isSnippetLoading,
          children: I18n.text('actions.save')
        })]
      })
    }), onCancel && /*#__PURE__*/_jsx(Button, {
      use: "secondary",
      responsive: false,
      size: "xs",
      onClick: onCancel,
      children: I18n.text('actions.cancel')
    })]
  });
}
export default CommentRichTextEditor;